export default __webpack_public_path__ + "static/media/english-to-hungarian-logo.a139267f.png";